/** Перевод интерфейса: английский. Ключ — русская фраза, {n} и т.п. — подстановки. */
export const en: Record<string, string> = {
  "дд.мм.гггг": "dd.mm.yyyy",
  "Дата в формате дд.мм.гггг": "Date format: dd.mm.yyyy",
  "Календарь": "Calendar",
  "Здесь появятся проведённые запросы и закупки.": "Posted requests and purchases will appear here.",
  "Меню": "Menu",
  "Демо-данные": "Demo data",
  "Язык интерфейса": "Interface language",
  "Светлая тема": "Light theme",
  "Тёмная тема": "Dark theme",
  "Тема": "Theme",
  "Журнал действий": "Activity log",
  "Не удалось сохранить название": "Could not save the name",
  "Загрузить демонстрационные данные?": "Load demo data?",
  "Текущие запросы и закупки будут заменены демонстрационным набором.": "Current requests and purchases will be replaced with the demo set.",
  "Загрузить заново": "Reload",
  "Отмена": "Cancel",
  "Демонстрационные данные загружены заново.": "Demo data reloaded.",
  "Не удалось загрузить": "Could not load",
  "Двойной щелчок — переименовать": "Double-click to rename",
  "Учёт запчастей": "Spare parts tracker",
  "Запросы и закупки": "Requests and purchasing",
  "В работе: {n}, просрочено: {m}": "In progress: {n}, overdue: {m}",
  "В работе: {n}": "In progress: {n}",
  "Сервис": "Service",
  "Проверка сервера": "Server check",
  "сменить роль": "switch role",
  "Работать как": "Work as",
  "Переименовать приложение": "Rename app",
  "Загрузить демо-данные": "Load demo data",
  "Новый запрос": "New request",
  "Закупка": "Purchasing",
  "Текущие запросы": "Current requests",
  "Статистика": "Statistics",
  "Нет строк": "No rows",
  "Проверка": "Check",
  "Готово": "Ready",
  "не переносить": "do not import",
  "Загрузка ответа фабрики": "Import factory reply",
  "Загрузите файл, который вернула фабрика. Строки сопоставляются по OEM, значения попадут в таблицу — провести их нужно будет как обычно, кнопкой «Проверить и провести».": "Upload the file returned by the factory. Rows are matched by OEM and the values go into the table — then post them as usual with «Review and post».",
  "Выбрать файл .xlsx": "Choose .xlsx file",
  "Лист": "Sheet",
  "Строка заголовков": "Header row",
  "Строка {n}": "Row {n}",
  "Не удалось прочитать файл": "Could not read the file",
  "Обрабатываю…": "Processing…",
  "Столбец с OEM": "OEM column",
  "Строк: {n}": "Rows: {n}",
  "Нет в запросах: {n}": "Not in requests: {n}",
  "Данные перенесены": "Data imported",
  "Перенести в таблицу ({n})": "Import into table ({n})",
  "от {date}": "from {date}",
  "на": "for",
  "закуплено": "purchased",
  "срок {date}": "due {date}",
  "Не удалось загрузить данные": "Could not load data",
  "Повторить": "Retry",
  "Загружаю данные…": "Loading data…",
  "позиция": "item",
  "позиций": "items",
  "Загружено позиций: {n}": "Items loaded: {n}",
  "Строк с ошибками: {n}. Исправьте их (см. столбец «Проверка»).": "Rows with errors: {n}. Fix them (see the «Check» column).",
  "Нельзя провести": "Cannot post",
  "Ошибка": "Error",
  "Не проведено": "Not posted",
  "Запрос № {no} проведён": "Request No. {no} posted",
  "отдел продаж: запрос клиента или правки к проведённому": "sales: a client request or changes to a posted one",
  "Он виден отделу закупки и на экране": "It is visible to procurement and on the screen",
  "Роль «{role}» может заполнять форму, но не проводить запросы. Сменить роль можно внизу боковой панели.": "The «{role}» role can fill in the form but cannot post requests. Switch roles at the bottom of the sidebar.",
  "Выберите запрос": "Select a request",
  "Не найдено": "Nothing found",
  "Сегодня, {date}": "Today, {date}",
  "Вставьте таблицу клиента в таблицу ниже: OEM, наименование, количество, цена.": "Paste the client's table below: OEM, name, quantity, price.",
  "Выберите номер запроса — его состав загрузится в таблицу.": "Select a request number — its items will load into the table.",
  "Загрузить состав": "Load items",
  "Очистить таблицу": "Clear table",
  "Скрыть инструкцию": "Hide instructions",
  "Как заполнять": "How to fill in",
  "Позиций": "Items",
  "Штук": "Pieces",
  "Сумма": "Amount",
  "С ошибками": "With errors",
  "Проверить и провести": "Review and post",
  "Таблица работает как в Excel: щелчок выделяет ячейку, двойной щелчок, Enter или начало набора — правка. Ctrl+C и Ctrl+V, выделение мышью, ширина столбцов запоминается.": "The table works like Excel: a click selects a cell; double-click, Enter or just typing starts editing. Ctrl+C and Ctrl+V, mouse selection; column widths are remembered.",
  "{n} млн": "{n}M",
  "{n} тыс": "{n}k",
  "по всем запросам и закупкам": "across all requests and purchases",
  "Не удалось загрузить статистику": "Could not load statistics",
  "Считаю статистику…": "Calculating statistics…",
  "Запросов": "Requests",
  "в работе {n}": "{n} in progress",
  "Сумма запросов": "Requested amount",
  "Выручка по закупленному": "Revenue on purchased",
  "{n} шт закуплено": "{n} pcs purchased",
  "Маржа": "Margin",
  "{n} % от выручки": "{n}% of revenue",
  "Суммы запросов по месяцам": "Requested amounts by month",
  "Запрошено": "Requested",
  "Выручка, затраты и маржа": "Revenue, cost and margin",
  "Выручка": "Revenue",
  "Затраты": "Cost",
  "Цены фабрики": "Factory prices",
  "CNY за штуку": "CNY per piece",
  "Пока мало данных: цена фабрики должна быть внесена хотя бы за два месяца.": "Not enough data yet: factory prices need at least two months.",
  "Изменение цен фабрики": "Factory price changes",
  "Наименование": "Name",
  "Было": "Before",
  "Стало": "After",
  "Изменение": "Change",
  "Изменений цен пока нет.": "No price changes yet.",
  "Топ позиций по закупленной сумме": "Top items by purchased amount",
  "Закуплено, шт": "Purchased, pcs",
  "Выручка, CNY": "Revenue, CNY",
  "Доля": "Share",
  "Маржа, CNY": "Margin, CNY",
  "Последний месяц к предыдущему": "Last month vs previous",
  "Нет заполненных строк. Заполните «Закупить».": "No filled rows. Fill in «Purchase».",
  "Нет заполненных строк. Заполните наличие и цену.": "No filled rows. Fill in stock and price.",
  "Проведено: {title}": "Posted: {title}",
  "наличие и цены фабрики, закупка по запросам": "factory stock and prices, purchasing by request",
  "Данные пересчитаны.": "Data recalculated.",
  "Роль «{role}» может заполнять форму, но не проводить. Сменить роль можно внизу боковой панели.": "The «{role}» role can fill in the form but cannot post. Switch roles at the bottom of the sidebar.",
  "Все открытые запросы": "All open requests",
  "Закупка распределится по открытым запросам по очереди, от старых к новым.": "The purchase will be spread across open requests, oldest first.",
  "Все OEM, которые ещё нужно закупить по открытым запросам.": "All OEMs still to be purchased for open requests.",
  "Запрос не выбран — выберите номер, чтобы подставить OEM.": "No request selected — choose a number to fill in OEMs.",
  "Загрузить OEM запроса": "Load request OEMs",
  "Выгрузить для фабрики": "Export for factory",
  "Загрузить ответ фабрики": "Import factory reply",
  "Заполнено строк": "Filled rows",
  "Закупить": "Purchase",
  "шт": "pcs",
  "Обратите внимание": "Please note",
  "У текущей роли нет прав на проведение.": "The current role is not allowed to post.",
  "Провести": "Post",
  "снято {n}": "{n} removed",
  "№ запроса / OEM": "Request No. / OEM",
  "OEM от закупки": "OEM from procurement",
  "Требуемое кол-во, шт": "Required qty, pcs",
  "Цена для клиента, CNY": "Client price, CNY",
  "Сумма для клиента, CNY": "Client amount, CNY",
  "Цена фабрики, CNY": "Factory price, CNY",
  "Сумма фабрики, CNY": "Factory amount, CNY",
  "Уже закуплено, шт": "Already purchased, pcs",
  "Закуплено на сумму для клиента, CNY": "Purchased, client value, CNY",
  "Нужно закупить, шт": "To purchase, pcs",
  "Излишек, шт": "Surplus, pcs",
  "Статус": "Status",
  "Автор": "Author",
  "Комментарий / примечание": "Comment / note",
  "Не удалось загрузить запросы": "Could not load requests",
  "что заказал клиент, что закуплено и что осталось": "what the client ordered, what is purchased and what is left",
  "Номер запроса, OEM, наименование": "Request No., OEM, name",
  "Очистить поиск": "Clear search",
  "Фильтр по статусу": "Filter by status",
  "Развернуть все запросы": "Expand all requests",
  "Развернуть": "Expand",
  "Свернуть все запросы": "Collapse all requests",
  "Свернуть": "Collapse",
  "Загружаю запросы…": "Loading requests…",
  "Нет запросов — измените фильтр или поиск": "No requests — change the filter or search",
  "Запросов в списке": "Requests in list",
  "Сумма для клиента": "Client amount",
  "Закуплено": "Purchased",
  "{a} из {b} шт": "{a} of {b} pcs",
  "Нужно закупить": "To purchase",
  "Все": "All",
  "В работе": "In progress",
  "Просрочены": "Overdue",
  "Выполнены": "Fulfilled",
  "Отменены": "Cancelled",
  "Версия {v}. Проверка сервера и базы данных.": "Version {v}. Server and database check.",
  "К приложению": "Back to app",
  "Проверяю…": "Checking…",
  "Всё работает": "Everything works",
  "Есть проблема": "There is a problem",
  "Сервер": "Server",
  "работает, {time}": "running, {time}",
  "База данных": "Database",
  "Папка базы": "Database folder",
  "Сервер базы": "Database server",
  "Миграции": "Migrations",
  "База создана": "Database created",
  "Время сервера": "Server time",
  "Москва": "Moscow",
  "Что проверить": "What to check",
  "Открыто ли окно консоли, которое запустил start.bat. Если окно закрыто — запустите start.bat снова. Если открыто — ошибка будет видна в нём: пришлите последние строки.": "Is the console window started by start.bat open? If it is closed, run start.bat again. If it is open, the error is shown there — send the last lines.",
  "Проверено в {time}": "Checked at {time}",
  "Проверить ещё раз": "Check again",
  "встроенная": "embedded",
  "сервер": "server",
  "подключена ({kind}), PostgreSQL {v}, отклик {ms} мс": "connected ({kind}), PostgreSQL {v}, response {ms} ms",
  "{n} с": "{n} s",
  "{n} мин": "{n} min",
  "{h} ч {m} мин": "{h} h {m} min",
  "Уменьшить таблицу": "Zoom out",
  "Увеличить таблицу": "Zoom in",
  "Масштаб таблиц (Ctrl + колёсико над таблицей)": "Table zoom (Ctrl + mouse wheel over a table)",
  "{n}% — обычный": "{n}% — normal",
  "Развернуть панель": "Expand panel",
  "Свернуть панель": "Collapse panel",
  "История": "History",
  "изменений: {n}": "changes: {n}",
  "Время / OEM": "Time / OEM",
  "Действие": "Action",
  "Наименование / подробности": "Name / details",
  "Что изменилось": "What changed",
  "Не удалось загрузить историю": "Could not load history",
  "кто, когда и что изменил": "who changed what and when",
  "OEM, № запроса, наименование": "OEM, request No., name",
  "Тип действия": "Action type",
  "Все авторы": "All authors",
  "Развернуть все": "Expand all",
  "Свернуть все": "Collapse all",
  "Загружаю историю…": "Loading history…",
  "Нет действий — измените фильтр или поиск": "No actions — change the filter or search",
  "Запросы": "Requests",
  "Наличие и закупка": "Stock and purchasing",
  "Прочее": "Other",
  "Нет изменений для проведения: обновите наличие или цену либо заполните «Закупить».": "Nothing to post: update stock or price, or fill in «Purchase».",
  "Изменено строк": "Changed rows",
  "Последнее проверенное наличие за вычетом закупленного после проверки": "Last checked stock minus what was purchased since",
  "Дата наличия": "Stock date",
  "Выгрузка в Excel": "Export to Excel",
  "Какие запросы": "Which requests",
  "Все запросы": "All requests",
  "Столбцы": "Columns",
  "Выбрать все": "Select all",
  "Снять все": "Clear all",
  "Выбор столбцов запоминается.": "Your column choice is remembered.",
  "Выгрузить": "Export",
  "Закрыть по закупленному и перенести недокупленное в новый запрос": "Close by what was purchased and move the rest into a new request",
  "Доступно отделу продаж и администратору": "Available to sales and administrator",
  "Перенести остаток": "Move remainder",
  "снятых: {n}": "removed: {n}",
  "без закупок": "no purchases",
  "Нельзя перенести": "Cannot move",
  "Остаток перенесён": "Remainder moved",
  "Закрыть по закупленному и перенести остаток": "Close by purchased and move the remainder",
  "В исходном запросе требуемое количество станет равным закупленному, а недокупленное попадёт в новый запрос. Закупки не меняются.": "In the original request the required quantity becomes equal to what was purchased, and the rest goes into a new request. Purchases do not change.",
  "Один запрос": "One request",
  "Из какого запроса": "From which request",
  "Нет запросов с недокупленным": "No requests with unpurchased items",
  "Включать запросы без закупок": "Include requests with no purchases",
  "Такие запросы перейдут целиком, исходные станут «Отменено».": "Such requests move over whole; the originals become «Cancelled».",
  "Включать позиции, снятые клиентом": "Include items removed by the client",
  "Вернутся в новый запрос в количестве до снятия. Каждая переносится только один раз.": "They return to the new request in the quantity before removal. Each is moved only once.",
  "№ нового запроса": "New request No.",
  "Пусто — «Остаток из запроса № …»": "Empty — «Remainder from request No. …»",
  "Предпросмотр": "Preview",
  "Закрыть и создать запрос": "Close and create request",
  "Частично": "Partial",
  "Ожидает": "Waiting",
  "Не отменено": "Not undone",
  "Действие отменено": "Action undone",
  "Отменить последнее действие": "Undo last action",
  "Отменять нечего: проведённых действий нет.": "Nothing to undo: there are no posted actions.",
  "Данные вернутся к состоянию до этого действия: запросы — к прежнему составу, добавленные записи будут удалены. Отменять можно по одному действию, начиная с последнего.": "Data returns to its state before this action: requests get their previous items back, added records are deleted. Actions are undone one at a time, starting with the latest.",
  "Отменить действие": "Undo action",
  "Пароли не совпадают.": "Passwords do not match.",
  "Имя и пароль": "Name and password",
  "Имя": "Name",
  "Оно будет видно в истории действий.": "It will be shown in the action history.",
  "Сохранить имя": "Save name",
  "Сменить пароль": "Change password",
  "Текущий пароль": "Current password",
  "Новый пароль": "New password",
  "Не короче {n} символов.": "At least {n} characters.",
  "Пароль ещё раз": "Repeat password",
  "Пользователи": "Users",
  "Ждут подтверждения: {n}": "Awaiting approval: {n}",
  "Выйти": "Sign out",
  "Роль «{role}» может заполнять форму, но не проводить запросы. Права выдаёт администратор.": "The «{role}» role can fill in the form but cannot post requests. Permissions are granted by the administrator.",
  "Роль «{role}» может заполнять форму, но не проводить. Права выдаёт администратор.": "The «{role}» role can fill in the form but cannot post. Permissions are granted by the administrator.",
  "Удалить пользователя {name}?": "Delete user {name}?",
  "Войти он больше не сможет. Его действия в истории сохранятся.": "They will no longer be able to sign in. Their actions stay in the history.",
  "Удалить": "Delete",
  "это вы": "you",
  "Подтвердить": "Approve",
  "Действия": "Actions",
  "Задать новый пароль": "Set new password",
  "Отключить": "Disable",
  "Включить": "Enable",
  "Пользователь": "User",
  "Роль": "Role",
  "Последний вход": "Last sign-in",
  "доступ, роли и заявки на вход": "access, roles and sign-up requests",
  "Добавить пользователя": "Add user",
  "Ждут подтверждения": "Awaiting approval",
  "Выберите роль и нажмите «Подтвердить» — после этого человек сможет войти.": "Choose a role and click «Approve» — then the person can sign in.",
  "Роли: «Продажи» — запросы клиента и перенос остатка; «Закупки» — наличие и закупка; «Администратор» — всё, включая пользователей и отмену действий.": "Roles: «Sales» — client requests and moving remainders; «Procurement» — stock and purchasing; «Administrator» — everything, including users and undo.",
  "E-mail": "E-mail",
  "Пароль": "Password",
  "Не короче {n} символов. Сообщите его пользователю — сменить можно в меню «Имя и пароль».": "At least {n} characters. Give it to the user — they can change it in «Name and password».",
  "Добавить": "Add",
  "Новый пароль: {name}": "New password: {name}",
  "Не короче {n} символов. Пользователь выйдет со всех устройств.": "At least {n} characters. The user will be signed out on all devices.",
  "Сохранить": "Save",
  "Вход": "Sign in",
  "Регистрация": "Sign up",
  "Войти": "Sign in",
  "Отправить заявку": "Send request",
  "Войти можно будет после того, как администратор подтвердит доступ и назначит роль.": "You can sign in after the administrator approves access and assigns a role.",
  "Работает": "Active",
  "Ждёт подтверждения": "Awaiting approval",
  "Отключён": "Disabled",
  "E-mail или логин": "E-mail or login",
  "На ПК: открыто ли окно консоли, которое запустил start.bat (если закрыто — запустите снова; если открыто — пришлите последние строки из него). На сервере: выполните sudo partsctl status и sudo partsctl logs.": "On a PC: is the console window started by start.bat open (if closed — run it again; if open — send its last lines). On a server: run sudo partsctl status and sudo partsctl logs.",
  "Запросов нет": "No requests",
  "Строк с ошибками: {n}": "Rows with errors: {n}",
  "Строки {rows}. Причина — в столбце «Проверка» этих строк.": "Rows {rows}. The reason is in the «Check» column of these rows.",
  "Причина — в столбце «Проверка».": "The reason is in the «Check» column.",
  "Открыт": "Open",
  "Частично выполнен": "Partially fulfilled",
  "Выполнен": "Fulfilled",
  "Просрочен": "Overdue",
  "Отменено": "Cancelled",
  "Ожидает закупки": "Awaiting purchase",
  "Частично закуплено": "Partially purchased",
  "Излишек": "Surplus",
  "Администратор": "Administrator",
  "Продажи": "Sales",
  "Закупки": "Procurement",
  "Система": "System",
  "Изменение запроса": "Change request",
  "Наличие и цены фабрики": "Factory stock and prices",
  "OEM": "OEM",
  "Количество, шт": "Quantity, pcs",
  "Цена продажи, CNY": "Sale price, CNY",
  "Примечание": "Note",
  "Требуется, шт": "Required, pcs",
  "В наличии у фабрики, шт": "Factory has in stock, pcs",
  "Наличие у фабрики, шт": "Factory stock, pcs",
  "Закупить, шт": "Purchase, pcs",
  "HS code": "HS code",
  "№ партии": "Batch No.",
  "№ коробки": "Box No.",
  "№ запроса": "Request No.",
  "Дата": "Date",
  "Срок поставки": "Delivery date",
  "Комментарий": "Comment",
  "Дата операции": "Operation date",
  "Поставщик": "Supplier",
  "№ счёта": "Invoice No.",
  "Необязательно": "Optional",
  "Уникальный номер нового запроса": "A unique number for the new request",
  "Выберите номер — состав загрузится сам": "Pick a number — the items load automatically",
  "Дата таблицы клиента (пусто — сегодня)": "Date of the client's table (empty — today)",
  "Дата правки (пусто — сегодня)": "Date of the change (empty — today)",
  "Заполняется позже, когда срок станет известен": "Filled in later, when the date is known",
  "Выберите запрос — OEM подставятся сами. «Все открытые запросы» — вся текущая потребность": "Pick a request and its OEMs fill in. «All open requests» — the whole current demand",
  "Выберите запрос — OEM подставятся сами, закупка закрепится за ним. «Все открытые запросы» — по очереди от старых к новым": "Pick a request: its OEMs fill in and the purchase is tied to it. «All open requests» — oldest first",
  "Дата проверки наличия, закупки или упаковки (пусто — сегодня)": "Date of the stock check or purchase (empty — today)",
  "Фабрика или поставщик": "Factory or supplier",
  "Номер счёта фабрики": "Factory invoice number",
  "Заполните номер запроса и вставьте таблицу клиента: OEM, наименование, количество, цена.": "Enter the request number and paste the client's table: OEM, name, quantity, price.",
  "Цена — та, по которой продаём клиенту. По ней считаются суммы и маржа.": "The price is what we sell to the client for. Amounts and margin are calculated from it.",
  "Номер должен быть новым: если такой запрос уже есть, переключитесь в режим «Изменение запроса».": "The number must be new: if the request already exists, switch to «Change request».",
  "Выберите номер запроса — текущий состав загрузится в таблицу.": "Pick the request number — its current items load into the table.",
  "Поправьте количества и цены, добавьте новые строки. Чтобы снять позицию, поставьте количество 0 или удалите строку.": "Adjust quantities and prices, add new rows. To remove an item, set its quantity to 0 or delete the row.",
  "Можно вставить новую таблицу клиента целиком: позиций, которых в ней нет, станет 0.": "You can paste a whole new client table: items missing from it become 0.",
  "Если запрос нужно закрыть частично, поставьте нужные количества — остальное останется в работе.": "To close a request partially, set the needed quantities — the rest stays in progress.",
  "Выберите запрос — OEM подставятся автоматически. «Требуется» — сколько ещё нужно закупить.": "Pick a request and its OEMs fill in automatically. «Required» is how much is still to purchase.",
  "Для каждой строки обязательны наличие у фабрики и цена; HS code желательно заполнить (подставляется, если уже вносился).": "Each row needs factory stock and price; HS code is recommended (filled in if entered before).",
  "Если OEM нужно изменить — укажите правильный в столбце «OEM от закупки»: отдел продаж получит уведомление.": "If the OEM must change, enter the correct one in «OEM from procurement»: sales will be notified.",
  "Строки без наличия и цены не проводятся.": "Rows without stock and price are not posted.",
  "Заполните «Закупить». Цена фабрики, HS code и «OEM от закупки» подставляются из режима «Наличие и цены фабрики» — исправьте цену, если она изменилась.": "Fill in «Purchase». Factory price, HS code and «OEM from procurement» come from «Factory stock and prices» — correct the price if it changed.",
  "Выбран конкретный запрос — закупка закрепляется за ним, и больше, чем требуется по этому запросу, закупить нельзя.": "With a specific request selected, the purchase is tied to it and cannot exceed what that request needs.",
  "«Все открытые запросы» — закупка распределяется по очереди от старых запросов к новым, лимит — общая потребность по OEM.": "«All open requests» — the purchase is spread oldest first; the limit is the total demand per OEM.",
  "Нельзя закупить больше, чем «В наличии у фабрики» (если наличие проверялось). Строки без «Закупить» не проводятся.": "You cannot buy more than «Factory has in stock» (if stock was checked). Rows without «Purchase» are not posted.",
  "Загружено строк: {n}": "Rows loaded: {n}",
  "Сначала выберите № запроса.": "Select a request number first.",
  "Выбранный запрос не найден.": "The selected request was not found.",
  "Нет позиций: всё уже закуплено.": "No items: everything is already purchased.",
  "Нет OEM": "No OEM",
  "OEM не найден в запросах": "OEM not found in requests",
  "Дубль OEM": "Duplicate OEM",
  "Наличие не число": "Stock is not a number",
  "Цена не число": "Price is not a number",
  "«Закупить» не число": "«Purchase» is not a number",
  "Отрицательное значение": "Negative value",
  "Кол-во не целое": "Quantity is not whole",
  "Не указано наличие": "Stock is missing",
  "Не указана цена": "Price is missing",
  "Не указано «Закупить»": "«Purchase» is missing",
  "«Закупить» должно быть больше 0": "«Purchase» must be greater than 0",
  "Выбранный запрос не найден": "The selected request was not found",
  "OEM нет в выбранном запросе (или снят клиентом)": "OEM is not in the selected request (or removed by the client)",
  "По запросу уже закуплено полностью": "Already fully purchased for this request",
  "Больше, чем нужно по запросу (макс. {n})": "More than the request needs (max {n})",
  "Потребность по OEM уже закрыта": "Demand for this OEM is already covered",
  "Больше общей потребности (макс. {n})": "More than total demand (max {n})",
  "Больше наличия у фабрики (доступно {n})": "More than factory stock ({n} available)",
  "Не указано количество": "Quantity is missing",
  "Кол-во не число": "Quantity is not a number",
  "Кол-во меньше 0": "Quantity below 0",
  "Кол-во 0 в новом запросе": "Quantity 0 in a new request",
  "Цена меньше 0": "Price below 0",
  "Нет заполненных строк для проведения. Заполните наличие, цену или «Закупить».": "No filled rows to post. Fill in stock, price or «Purchase».",
  "Строк с ошибками: {n}. Исправьте их (см. столбец «Проверка») и повторите.": "Rows with errors: {n}. Fix them (see the «Check» column) and try again.",
  "Дата операции указана некорректно.": "The operation date is invalid.",
  "Выбранный запрос не найден. Выберите номер из списка.": "The selected request was not found. Pick a number from the list.",
  "{n} (без изменений)": "{n} (unchanged)",
  "Наличие, шт": "Stock, pcs",
  "К закупке, шт": "To purchase, pcs",
  "Можно купить сейчас, шт": "Can buy now, pcs",
  "Закупка по запросу № {no}": "Purchase for request No. {no}",
  "Закупка по всем открытым запросам": "Purchase across all open requests",
  "Нужно по запросу, шт": "Needed for request, pcs",
  "Нужно по всем запросам, шт": "Needed for all requests, pcs",
  "OEM от закупки (для отдела продаж)": "OEM from procurement (for sales)",
  "Сумма по ценам фабрики": "Amount at factory prices",
  "Режим": "Mode",
  "Запрос": "Request",
  "все открытые запросы": "all open requests",
  "«Можно купить сейчас» — меньшее из «К закупке» и нового наличия.": "«Can buy now» is the smaller of «To purchase» and the new stock.",
  "Закупка будет закреплена за запросом № {no}.": "The purchase will be tied to request No. {no}.",
  "Закупка будет распределена по открытым запросам по очереди, начиная с самого старого.": "The purchase will be spread across open requests, starting with the oldest.",
  "Цена фабрики изменится у позиций: {n} (показано стрелкой).": "Factory price will change for {n} items (shown with an arrow).",
  "Отдел продаж получит предложения по OEM: {n}.": "Sales will receive OEM suggestions: {n}.",
  "Не указан поставщик.": "Supplier is not specified.",
  "Не указан № счёта.": "Invoice No. is not specified.",
  "запрос № {no}": "request No. {no}",
  "счёт {n}": "invoice {n}",
  "Всего, шт": "Total, pcs",
  "Кол-во, шт": "Qty, pcs",
  "Укажите № запроса.": "Enter the request number.",
  "Дата указана некорректно.": "The date is invalid.",
  "Срок поставки указан некорректно.": "The delivery date is invalid.",
  "Запрос № {no} уже существует. Для правок выберите режим «Изменение запроса».": "Request No. {no} already exists. To edit it, choose «Change request».",
  "Нет строк для проведения.": "No rows to post.",
  "Запрос № {no} не найден. Выберите номер из списка.": "Request No. {no} not found. Pick a number from the list.",
  "Нет в актуальной таблице клиента": "Not in the current client table",
  "Изменений нет: таблица совпадает с текущим состоянием запроса № {no}.": "No changes: the table matches request No. {no}.",
  "Новые позиции": "New items",
  "Добавлено": "Added",
  "Изменено": "Changed",
  "Удалено (количество станет 0)": "Removed (quantity becomes 0)",
  "Без изменений: {n} поз.": "Unchanged: {n} items",
  "Снимается позиций: {n}. Уже закупленное по ним останется как излишек.": "Items being removed: {n}. Anything already purchased for them stays as surplus.",
  "Новый запрос № {no}": "New request No. {no}",
  "Изменение запроса № {no}": "Change to request No. {no}",
  "После проведения запрос попадёт в работу к отделу закупки.": "After posting, the request goes to procurement.",
  "Отдел закупки увидит новые количества при следующем выборе запроса.": "Procurement will see the new quantities next time they select the request.",
  "У роли «{role}» нет прав на {what}.": "The «{role}» role is not allowed to perform {what}.",
  "проведение запросов": "posting requests",
  "это проведение": "this posting",
  "изменение названия приложения": "renaming the app",
  "сброс демонстрационных данных": "resetting demo data",
  "База пустая — загружены демонстрационные данные": "The database was empty — demo data loaded",
  "Демонстрационные данные загружены заново": "Demo data reloaded",
  "Запрос № {no} не найден.": "Request No. {no} not found.",
  "Пока был открыт предпросмотр, данные изменились. Откройте предпросмотр заново.": "The data changed while the preview was open. Open the preview again.",
  "Проведено: {title}, позиций: {n}": "Posted: {title}, items: {n}",
  "Проведено позиций: {n}.": "Items posted: {n}.",
  "Проведено: {title}, строк: {n}": "Posted: {title}, rows: {n}",
  "Проведено строк: {n}.": "Rows posted: {n}.",
  "Название не может быть пустым.": "The name cannot be empty.",
  "Нет позиций для выгрузки: всё уже закуплено.": "Nothing to export: everything is already purchased.",
  "Нет такой выгрузки.": "No such export.",
  "Выгрузка в Excel: {name}": "Excel export: {name}",
  "Сервер не отвечает. Проверьте, что окно приложения (start.bat) открыто.": "The server is not responding. Check that the app window (start.bat) is open.",
  "Ошибка сервера ({n})": "Server error ({n})",
  "№ {no}": "No. {no}",
  "позиций: {n}": "items: {n}",
  "строк: {n}": "rows: {n}",
  "изменён срок": "delivery date changed",
  "Название приложения": "App name",
  "Демонстрационные данные": "Demo data",
  "Загружены заново": "Reloaded",
  "Загрузка фото": "Photo upload",
  "Удаление фото": "Photo deleted",
  "Основное фото": "Main photo",
  "файлов: {n}": "files: {n}",
  "Упаковка": "Packing",
  "инвойс {n}": "invoice {n}",
  "штук: {n}": "pcs: {n}",
  "Выберите запрос — подставятся OEM, которые ещё нужно закупить, с последним наличием и ценой. «Все открытые запросы» — вся текущая потребность": "Pick a request: the OEMs still to buy fill in with the last stock and price. «All open requests» — the whole current demand",
  "Дата проверки наличия или закупки (пусто — сегодня)": "Date of the stock check or purchase (empty — today)",
  "Выберите запрос — подставятся OEM, которые ещё нужно закупить. Наличие у фабрики, цена, HS code и «OEM от закупки» подтягиваются из прошлых проведений.": "Pick a request — the OEMs still to buy fill in. Factory stock, price, HS code and «OEM from procurement» come from earlier postings.",
  "Можно заполнить только наличие и цену — они сохранятся, и в следующий раз останется указать «Закупить». Можно сразу и то и другое.": "You can fill in only stock and price — they are saved, and next time you only need «Purchase». Or do both at once.",
  "Проводятся только строки, где что-то изменилось: новое наличие, цена, HS code, «OEM от закупки» или заполнено «Закупить».": "Only rows where something changed are posted: new stock, price, HS code, «OEM from procurement» or a filled «Purchase».",
  "Выбран конкретный запрос — закупка закрепляется за ним и не может быть больше, чем нужно по нему. «Все открытые запросы» — закупка распределяется от старых запросов к новым.": "With a specific request, the purchase is tied to it and cannot exceed its need. «All open requests» — the purchase is spread oldest first.",
  "Нельзя закупить больше, чем есть у фабрики: берётся введённое в строке наличие, а если его не меняли — последнее известное.": "You cannot buy more than the factory has: the stock entered in the row is used, or the last known one if unchanged.",
  "Останется у фабрики, шт": "Left at factory, pcs",
  "Обновлено наличие": "Stock updated",
  "Будут сохранены наличие и цены фабрики. «Закупить» можно заполнить позже — наличие подтянется само.": "Factory stock and prices will be saved. «Purchase» can be filled in later — the stock will fill in automatically.",
  "дата {d}": "date {d}",
  "поставщик: {s}": "supplier: {s}",
  "наличие и цены: {n}": "stock and prices: {n}",
  "закуплено позиций: {n}": "items purchased: {n}",
  "добавлено: {n}": "added: {n}",
  "изменено: {n}": "changed: {n}",
  "снято: {n}": "removed: {n}",
  "Укажите № нового запроса.": "Enter the new request number.",
  "Запрос № {no} уже существует. Укажите другой номер.": "Request No. {no} already exists. Use another number.",
  "Выберите запрос, из которого переносится остаток.": "Select the request to move the remainder from.",
  "{no} (снято {n})": "{no} (removed {n})",
  "Нечего переносить: по запросу всё закуплено.": "Nothing to move: everything in this request is purchased.",
  "Нечего переносить: нет запросов с недокупленными позициями. Проверьте галочки.": "Nothing to move: no requests with unpurchased items. Check the options.",
  "Из запросов № {src}": "From requests No. {src}",
  "Из запроса № {src}": "From request No. {src}",
  "Цены для клиента различались у позиций: {n}. Взята цена самого нового запроса (отмечено ⚠).": "Client prices differed for {n} items. The price from the newest request is used (marked ⚠).",
  "Срок поставки нового запроса не указан.": "The new request has no delivery date.",
  "Остаток из запроса № {src}": "Remainder from request No. {src}",
  "снята клиентом": "removed by client",
  "Закрываются по закупленному": "Closed by purchased",
  "Требовалось, шт": "Was required, pcs",
  "Станет (закуплено), шт": "Becomes (purchased), pcs",
  "Переносится, шт": "Moved, pcs",
  "Сумма, CNY": "Amount, CNY",
  "Откуда": "From",
  "Перенос остатка → новый запрос № {no}": "Remainder moved → new request No. {no}",
  "Закрываются": "Being closed",
  "В закрываемых запросах требуемое количество станет равным закупленному (статус «Выполнен»). Недокупленное попадёт в новый запрос. Закупки, упаковка и фото не меняются.": "In the closed requests the required quantity becomes equal to what was purchased («Fulfilled»). The rest goes into the new request. Purchases, packing and photos do not change.",
  "Запросов закрывается": "Requests closed",
  "Позиций в новом запросе": "Items in new request",
  "Запрос № {no} уже существует.": "Request No. {no} already exists.",
  "Закрыт по закупленному, остаток → № {no}": "Closed by purchased, remainder → No. {no}",
  "Перенесено {n} шт в запрос № {no}": "{n} pcs moved to request No. {no}",
  "Снятая клиентом позиция перенесена в запрос № {no}": "Item removed by the client moved to request No. {no}",
  "Перенос остатка": "Remainder moved",
  "Закрыт по закупленному": "Closed by purchased",
  "перенесено позиций: {n}": "items moved: {n}",
  "Создан запрос № {no}, позиций: {n}.": "Request No. {no} created, items: {n}.",
  "перенос остатка": "moving the remainder",
  "Отмена действия": "Action undone",
  "Отменено: {t}.": "Undone: {t}.",
  "Отменять нечего.": "Nothing to undo.",
  "Последнее действие уже другое. Обновите страницу и проверьте, что отменяете.": "The last action has changed. Reload the page and check what you are undoing.",
  "отмену действий": "undoing actions",
  "Перенос остатка: № {a} → № {b}": "Remainder moved: No. {a} → No. {b}",
  "Дата выполнения: {d}": "Completed on: {d}",
  "Войдите в приложение.": "Please sign in.",
  "Неверный e-mail или пароль.": "Wrong e-mail or password.",
  "Слишком много неудачных попыток. Подождите 15 минут.": "Too many failed attempts. Wait 15 minutes.",
  "Доступ ещё не подтверждён администратором.": "Access has not been approved by the administrator yet.",
  "Пользователь отключён. Обратитесь к администратору.": "User is disabled. Contact the administrator.",
  "Регистрация отключена. Обратитесь к администратору.": "Sign-up is disabled. Contact the administrator.",
  "Укажите корректный e-mail.": "Enter a valid e-mail.",
  "Укажите имя — оно будет видно в истории действий.": "Enter your name — it will be shown in the action history.",
  "Пароль — не короче {n} символов.": "Password must be at least {n} characters.",
  "Пользователь с таким e-mail уже есть.": "A user with this e-mail already exists.",
  "Заявка отправлена. Войти можно будет после подтверждения администратором.": "Request sent. You can sign in after the administrator approves it.",
  "Текущий пароль указан неверно.": "Current password is wrong.",
  "Пароль изменён. Войдите заново с новым паролем.": "Password changed. Sign in again with the new password.",
  "Укажите имя.": "Enter a name.",
  "Имя сохранено.": "Name saved.",
  "Пользователь не найден.": "User not found.",
  "Нельзя: это последний администратор.": "Not allowed: this is the last administrator.",
  "Укажите e-mail.": "Enter an e-mail.",
  "Выберите роль.": "Choose a role.",
  "Пользователь добавлен.": "User added.",
  "Неизвестная роль.": "Unknown role.",
  "Неизвестный статус.": "Unknown status.",
  "Сохранено.": "Saved.",
  "Пароль изменён. Сообщите его пользователю.": "Password changed. Give it to the user.",
  "Нельзя удалить самого себя.": "You cannot delete yourself.",
  "Пользователь удалён. Его действия в истории сохранятся.": "User deleted. Their actions stay in the history.",
  "Запрос с другого сайта отклонён.": "Request from another site rejected.",
  "управление пользователями": "managing users",
  "Сервер не отвечает. Проверьте подключение к интернету или попробуйте позже.": "The server is not responding. Check your internet connection or try later.",
  "OEM повторяется в строках {rows}": "OEM repeated in rows {rows}",
  "OEM повторяется в строках {rows}: OEM упаковывается целиком в одну коробку": "OEM repeated in rows {rows}: an OEM is packed whole into one box"
};
